import { Button, Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { capitalizeFirstLetter, withFullStop } from 'BreetHelpers';
import { useCountDown } from 'BreetHooks';
import { useCallback } from 'react';

import type { IOTPResend } from '../helpers';

export const Resend = ({ initialCountdown, onResend, isLoading, errorMessage, cta, position }: IOTPResend) => {
	const { countdown, restartCountDown } = useCountDown(initialCountdown);

	const canResend = countdown === 0;

	const message = cta?.message ?? "Didn't receive code?";

	const handleOTPResend = useCallback(() => {
		onResend?.(restartCountDown);
	}, [onResend, restartCountDown]);

	const getResendPrompt = () => {
		let Component = (
			<>
				Resend in <span className='color-tertiary-400'>{countdown}s</span>
			</>
		);

		if (canResend || cta?.message) {
			Component = (
				<Button
					label={cta?.btnTitle ?? 'Resend'}
					onClick={cta?.action ?? handleOTPResend}
					type='button'
					variant='native'
					className='color-tertiary-400'
				/>
			);
		}

		if (isLoading) {
			Component = <span className='color-tertiary-400'>Sending...</span>;
		}

		return (
			<Typography
				variant='paragraph_1'
				className='color-primary-50'
			>
				{capitalizeFirstLetter(message)} {Component}
			</Typography>
		);
	};

	return (
		<div
			className={classNameMerger('otp_resend', errorMessage && 'error', position)}
			data-testid='resend-otp'
		>
			{errorMessage && (
				<Typography
					variant='paragraph_1'
					className='otp_resend-error color-error-400'
				>
					{withFullStop(capitalizeFirstLetter(errorMessage))}
				</Typography>
			)}

			{getResendPrompt()}
		</div>
	);
};
